/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import PropTypes from 'prop-types';
import * as Colors from 'styles/colors';
import { defaultFont } from 'styles/fonts';
import { MEDIA_QUERIES } from 'styles/constants';
import { propTypeLength } from 'utils/propValidation';
import { getLength } from 'utils/cssStringManipulation';

const Text = (props) => {
  const {
    children,
    className,
    fontSize = 12,
    fontSizeMobile,
    align = 'left',
    type = 'block',
    lineHeightMobile,
    color = Colors.BLACK,
    fontWeight = 'normal',
    lineHeight = fontSize * 1.2,
    ...rest
  } = props;

  const styles = css`
    color: ${color};
    text-align: ${align};
    font-size: ${fontSize}px;
    ${getLength({ 'line-height': lineHeight })};
    font-family: ${defaultFont};
    font-weight: ${fontWeight};

    ${MEDIA_QUERIES.mobile} {
      ${getLength({
        'font-size': fontSizeMobile,
        'line-height': lineHeightMobile || fontSizeMobile * 1.2,
      })}
    }
  `;

  let ReactElement;

  switch (type) {
    case 'block':
      ReactElement = 'div';
      break;
    case 'inline':
      ReactElement = 'span';
      break;
    case 'h1':
      ReactElement = 'h1';
      break;
    case 'h2':
      ReactElement = 'h2';
      break;
    case 'h3':
      ReactElement = 'h3';
      break;
    default:
      throw new Error('Unhandled text type');
  }

  return (
    <ReactElement css={styles} className={className} {...rest}>
      {children}
    </ReactElement>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(Colors)),
  fontSize: PropTypes.number,
  fontSizeMobile: PropTypes.number,
  lineHeightMobile: propTypeLength,
  fontWeight: PropTypes.oneOf([
    'inherit',
    'initial',
    'revert',
    'revert-layer',
    'unset',
    'normal',
    'bold',
    'lighter',
    'bolder',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
  ]),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  lineHeight: propTypeLength,
  type: PropTypes.oneOf(['block', 'inline', 'h1', 'h2', 'h3']),
};

export default Text;
